import routerOptions0 from "/opt/build/repo/node_modules/.pnpm/nuxt@3.10.1_@parcel+watcher@2.5.1_@types+node@22.13.1_magicast@0.3.5_rollup@4.30.1_sass@1.83._ednasnbfpsum6n75mij7x5rnmu/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}